import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml, SafeUrl, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-image',
  templateUrl: './image-chat-bubble.component.html',
  styleUrls: ['./image-chat-bubble.component.scss'],
})
export class ImageComponent implements OnInit, AfterViewInit {
  @Input() messageSource: Boolean;
  @Input() content: any;

  constructor(private dialog: MatDialog, public sanitization: DomSanitizer) {}

  public previewImageSrc: any;
  public previewCaption: any;
  public imageModule: any;

  @ViewChild('previewImageModule', { static: true }) previewImageModule: TemplateRef<any>;
  @ViewChild('divElement', { static: true }) divElement: ElementRef;
  @ViewChild('imgElement', { static: true }) imgElement: ElementRef;

  ngOnInit() {
    this.previewCaption = this.content['description'];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.imageSizeCalculation();
    }, 100);
  }

  previewImage(imagePreview: any) {
    this.previewImageSrc = this.sanitization.bypassSecurityTrustUrl(imagePreview);
    this.imageModule = this.dialog.open(this.previewImageModule, {
      panelClass: 'previewImage',
      width: '499px',
      height: 'auto',
      disableClose: true,
    });
  }

  onClosePreview() {
    this.imageModule.close();
  }

  async imageSizeCalculation() {
    if (this.imgElement.nativeElement.naturalWidth > this.imgElement.nativeElement.naturalHeight) {
      this.divElement.nativeElement.style.height = 'auto';
      this.divElement.nativeElement.style.maxWidth = '236px';
    } else {
      this.divElement.nativeElement.style.maxHeight = '226px';
      this.divElement.nativeElement.style.maxWidth = '175px';
    }
  }
}
